module.exports = __webpack_public_path__ + "static/media/aba.bd9afb79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/aba.svg
// module id = 369
// module chunks = 25